
export const test_url_aws         = "https://housingapi.dev.nidhi.apcfss.in/ofmsapi/OfmsLogout";
export const live_url             = "https://api.apshclfms.apcfss.in/ofmsapi/OfmsLogout";
// export const system_url           = "http://192.168.1.155:8082/ofmsapi/OfmsLogout";
export const TOKEN_INVALIDATE_URL  = live_url;


